(function () {
  var STORAGE_KEY = 'ak_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(handles) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
  }

  function refreshButtons() {
    var handles = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-id');
      var active = handles.indexOf(handle) !== -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    var bubble = document.getElementById('wishlist-count-bubble');
    if (bubble) {
      bubble.textContent = handles.length;
      bubble.classList.toggle('opacity-0', handles.length === 0);
    }

    var drawerCount = document.getElementById('wishlist-drawer-count');
    if (drawerCount) {
      drawerCount.textContent = handles.length;
    }
  }

  function formatPrice(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function getCartDrawerSectionId() {
    var cartDrawer = document.getElementById('cart-drawer');
    var el = cartDrawer;
    while (el) {
      if (el.id && el.id.indexOf('shopify-section-') === 0) {
        return el.id.replace('shopify-section-', '');
      }
      el = el.parentElement;
    }
    return null;
  }

function renderDrawer() {
    var body = document.getElementById('wishlist-drawer-body');
    if (!body) return;

    var handles = getWishlist();

    if (handles.length === 0) {
      body.innerHTML = '<p class="wishlist-drawer__empty">Noch keine Favoriten gemerkt.</p>';
      return;
    }

    body.innerHTML = '<p class="wishlist-drawer__empty">Lädt...</p>';

    Promise.all(
      handles.map(function (handle) {
        return fetch('/products/' + handle + '.js')
          .then(function (r) {
            if (!r.ok) return null;
            return r.json();
          })
          .catch(function () {
            return null;
          });
      })
    ).then(function (products) {
      var html = '';

      products.forEach(function (item, index) {
        if (!item) return;

        var handle = handles[index];
        var availableVariants = item.variants.filter(function (v) {
          return v.available;
        });

        var displayVariant = availableVariants[0] || item.variants[0];
        var image = item.featured_image || (item.images.length > 0 ? item.images[0] : null);

        var actionsHtml;
        if (availableVariants.length === 0) {
          actionsHtml = '<p class="wishlist-drawer__sold-out">Ausverkauft</p>';
        } else {
          var optionsHtml = availableVariants
            .map(function (v) {
              return '<option value="' + v.id + '">' + (v.option1 || v.title) + '</option>';
            })
            .join('');

          actionsHtml =
            '<select class="wishlist-drawer__size-select" data-wishlist-size-select aria-label="Größe wählen">' +
              optionsHtml +
            '</select>' +
            '<button type="button" class="wishlist-drawer__add-btn" data-wishlist-add>In den Warenkorb</button>';
        }

        html +=
          '<div class="wishlist-drawer__item" data-wishlist-item="' + handle + '">' +
            (image ? '<img class="wishlist-drawer__item-image" src="' + image + '&width=112" alt="' + item.title.replace(/"/g, '') + '">' : '<div class="wishlist-drawer__item-image"></div>') +
            '<div class="wishlist-drawer__item-info">' +
              '<a class="wishlist-drawer__item-title" href="/products/' + handle + '">' + item.title + '</a>' +
              '<p class="wishlist-drawer__item-price">' + formatPrice(displayVariant.price) + '</p>' +
              '<div class="wishlist-drawer__item-actions">' +
                actionsHtml +
              '</div>' +
            '</div>' +
            '<button type="button" class="wishlist-drawer__remove-btn" data-wishlist-remove data-handle="' + handle + '" aria-label="Entfernen">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/><path d="M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg>' +
            '</button>' +
          '</div>';
      });

      body.innerHTML = html || '<p class="wishlist-drawer__empty">Noch keine Favoriten gemerkt.</p>';
    });
  }

  function openDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wishlist-drawer-open');
    renderDrawer();
  }

  function closeDrawer() {
    var drawer = document.getElementById('wishlist-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('wishlist-drawer-open');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-wishlist-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      e.stopPropagation();

      var handle = toggleBtn.getAttribute('data-product-id');
      var handles = getWishlist();
      var index = handles.indexOf(handle);

      if (index === -1) {
        handles.push(handle);
      } else {
        handles.splice(index, 1);
      }

      saveWishlist(handles);
      refreshButtons();

      var drawer = document.getElementById('wishlist-drawer');
      if (drawer && drawer.classList.contains('is-open')) {
        renderDrawer();
      }
      return;
    }

    var headerLink = e.target.closest('#header-wishlist-link');
    if (headerLink) {
      e.preventDefault();
      openDrawer();
      return;
    }

    var closeTrigger = e.target.closest('[data-wishlist-drawer-close]');
    if (closeTrigger) {
      closeDrawer();
      return;
    }

    var removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      var removeHandle = removeBtn.getAttribute('data-handle');
      var handles2 = getWishlist();
      var idx = handles2.indexOf(removeHandle);
      if (idx !== -1) {
        handles2.splice(idx, 1);
        saveWishlist(handles2);
        refreshButtons();
        renderDrawer();
      }
      return;
    }

var addBtn = e.target.closest('[data-wishlist-add]');
    if (addBtn) {
      var itemEl = addBtn.closest('[data-wishlist-item]');
      var sizeSelect = itemEl ? itemEl.querySelector('[data-wishlist-size-select]') : null;
      var variantId = sizeSelect ? sizeSelect.value : null;
      if (!variantId) return;
      addBtn.disabled = true;
      addBtn.textContent = '...';

      var addedSections = null;

      var sectionsParam = 'variant-added';
      var cartDrawerSectionId = getCartDrawerSectionId();
      if (cartDrawerSectionId) {
        sectionsParam += ',' + cartDrawerSectionId;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sectionsParam
        })
      })
      
        .then(function (r) {
          return r.json();
        })
        .then(function (addResult) {
          addedSections = addResult.sections;
          return fetch('/cart.js');
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          if (addedSections) {
            cart.sections = addedSections;
          }

          var cartCountEl = document.querySelector('a[href*="/cart"] .count-bubble');
          if (cartCountEl) {
            cartCountEl.textContent = cart.item_count;
            cartCountEl.classList.toggle('opacity-0', cart.item_count === 0);
          }

          document.documentElement.dispatchEvent(
            new CustomEvent('cart:change', {
              bubbles: true,
              detail: { baseEvent: 'variant:add', cart: cart }
            })
          );

          addBtn.textContent = 'Hinzugefügt ✓';
          setTimeout(function () {
            addBtn.disabled = false;
            addBtn.textContent = 'In den Warenkorb';
          }, 1500);
        })
        .catch(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'In den Warenkorb';
        });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  document.addEventListener('DOMContentLoaded', refreshButtons);
  if (document.readyState !== 'loading') {
    refreshButtons();
  }
})();